<template>
  <!-- ============================================================
       No.7 採択者の手続き追加：管理者「ファイル設定」タブ内の
       ①寄付申込書 / ②間接経費免除申請書 のフォーマット設定行。
       既存 cms/form/parts/File.vue の見た目に合わせ、削除ボタン（○×・No.12と共通）を追加。
       store 連動（fileData は cmsForm の fileDonation / fileExemption を受け取る）。
       ============================================================ -->
  <div>
    <b-input-group class="flex flexMiddle">
      <!-- 新規アップロード済み -->
      <span
        v-if="fileData.uploadedFileName"
        class="mb-2 fileName">
        ファイル名：{{ fileData.uploadedFileName }}
      </span>
      <!-- 設定済み（DB）ファイル・DLリンク -->
      <span
        v-else-if="fileData.dbFileName"
        class="mb-2 fileName">
        ファイル名：
        <b-link
          class="mb-1"
          @click="downloadFile(fileData.dbAssetId, fileData.dbFileName, false)">{{ fileData.dbFileName }}</b-link>
      </span>
      <!-- 未設定 -->
      <span
        v-else
        class="mb-2 fileName">
        ファイル名：ファイルが選択されていません。
      </span>

      <!-- 削除（新規選択 or 設定済みファイルがあるとき）。メール添付/追加資料と同じ共通アイコン（○×） -->
      <img
        v-if="!noInput && (fileData.uploadedFileName || fileData.dbFileName)"
        src="@/assets/svg/close_small.svg"
        class="tdDeleteBtn ml-3 mb-2"
        @click="onClickDelete">
    </b-input-group>

    <b-input-group>
      <div
        @dragover.prevent="toggleDrag(true)"
        @dragleave.prevent="toggleDrag(false)"
        @drop.prevent="onDrop($event)"
        :class="[isDragging ? 'is-dragging' : '', 'drop', 'flex', 'flexMiddle', 'flexCenter']">
        <span>
          <span
            :class="[isDragging ? 'is-dragging' : '', 'dragText', 'fw-6']"
            >ここにファイルをドラッグ＆ドロップ または</span>
          <label
            v-if="!noInput"
            :for="fileKey"
            class="fileText fw-6 selectFile">［ ファイルを選択 ］</label>
          <label
            v-if="noInput"
            class="fileText fw-6 selectFile">［ ファイルを選択 ］</label>
          <p :class="[isDragging ? 'is-dragging' : '', 'fileNotation', 'mb-0']">
            （ファイルを再アップロードした場合アップロード済みのファイルは上書きされます）
          </p>
          <input type="file" style="display:none;"
            :id="fileKey"
            @change="upload($event)">
        </span>
      </div>
    </b-input-group>
  </div>
</template>

<script>
export default {
  name: 'cmsFormAdoptionFile',
  props: {
    // input要素の一意キー（store のキー名と一致：fileDonation / fileExemption）
    fileKey: { type: String, required: true },
    // store の該当ファイル状態（dbFileName / dbAssetId / uploadedFileName 等）
    fileData: { type: Object, default: () => ({}) },
    downloadFile: { type: Function },
    noInput: { type: Boolean, default: true },
  },
  data() {
    return {
      isDragging: false,
    };
  },
  methods: {
    toggleDrag(isDragging) {
      this.isDragging = isDragging;
    },
    upload(event) {
      if (event.target.files.length === 0) {
        return;
      }
      if (this.noInput) {
        return;
      }
      const file = event.target.files[0];
      this.$emit('kickUpload', {
        uploadedFileName: file.name,
        uploadedFileKey: this.fileKey,
        realFile: file,
      });
      // 同じファイルを選び直しても @change が発火するよう input をクリア
      const fileInput = event.target;
      fileInput.value = '';
    },
    onDrop(event) {
      this.isDragging = false;
      const fileList = event.dataTransfer ? event.dataTransfer.files : event.target.files;
      if (!fileList || fileList.length === 0) {
        return;
      }
      if (this.noInput) {
        return;
      }
      const file = fileList[0];
      this.$emit('kickUpload', {
        uploadedFileName: file.name,
        uploadedFileKey: this.fileKey,
        realFile: file,
      });
    },
    onClickDelete() {
      if (this.noInput) {
        return;
      }
      this.$emit('kickDelete', this.fileKey);
    },
  },
};
</script>

<style scoped>
.tdDeleteBtn {
  cursor: pointer;
}
.drop {
  height: 120px;
  width: 100%;
  background-color: #F3F3F3;
  border-color: #CCC;
  border-style: dashed;
  border-radius: 10px;
  border-width: 1px;
}
.dragText {
  color: #BBB;
}
.fileText {
  color: #0A8EA7;
}
.fileNotation {
  color: #BBB;
}
.is-dragging.drop {
  background-color: #E6E6E6;
  border-color: #6E6E6E;
}
.is-dragging {
  color: #6E6E6E;
}
.selectFile {
  cursor: pointer;
}
.selectFile:hover {
  text-decoration: underline;
}
.fileName {
  margin-top: 16px;
}
</style>
